import { GatewayConfig } from "../../typings/gateway-api";
import { LocaleCode } from "../../typings/lang";
import { SaleTranslationsStatus } from "../../typings/translations";
import { postMessageToV2 } from "../../utils/sale-iframe";
import { TranslationsMixinController } from "./translations-mixin.controller";

export class TranslationsToolbarController extends TranslationsMixinController {
    public static $inject: string[] = ["$mdDialog", "$scope", "$translate", "toaster", "translationsService"];

    // binded
    public getTranslationStatus: Function;
    public setTranslationStatus: Function;
    public fetchAll: Function;
    public initiatePublish: Function;
    public isPast: boolean;
    public isPublishDisabled: boolean;
    public resourceId: number;
    public translationsStatus: SaleTranslationsStatus;
    public selectedTargetLanguage: LocaleCode;
    public sourceLang: LocaleCode;
    public saleId: any;

    public supportedTargetLanguages: LocaleCode[];

    constructor(
        $mdDialog: ng.material.IDialogService,
        public $scope,
        $translate: ng.translate.ITranslateService,
        toaster,
        private translationsService
    ) {
        super($mdDialog, $scope, $translate, toaster);

        $scope.$watch(
            () => this.selectedTargetLanguage,
            selectedTargetLanguage => postMessageToV2({ saleId: this.saleId, selectedTargetLanguage })
        );
    }

    public $onInit() {
        this.selectedTargetLanguage = this.sourceLang || LocaleCode.fr_FR;

        this.translationsService.getConfig().then(({ translations: { supported_target_lang } }: GatewayConfig) => {
            this.supportedTargetLanguages = supported_target_lang;

            if (!this.supportedTargetLanguages.includes(this.selectedTargetLanguage)) {
                this.supportedTargetLanguages.push(this.selectedTargetLanguage);
            }
        });
    }
}
